import React from 'react';
import '../../styles/Whot.css';

export default function WhotControls({
  onDrawCard,
  onRestart,
  onLeave,
  onPassTurn,
  onStopConfetti,
  canDraw,
  gameStatus,
  showDrawButton = true,
  showStopConfetti = false,
  drawnCard = null,
  pendingPick2Count = 0,
  pendingPick3Active = false,
  onOpenChat,
  unreadChatCount = 0,
}) {
  return (
    <div className="whot-controls" style={{ marginTop: 10, display: 'flex', gap: 10, justifyContent: 'center', flexWrap: 'wrap', alignItems: 'center' }}>
      {pendingPick2Count > 0 && (
        <div className="whot-pick-banner whot-pick-banner--danger">
          Pick {pendingPick2Count}
        </div>
      )}
      {pendingPick3Active && (
        <div className="whot-pick-banner whot-pick-banner--danger">
          Pick 3 or counter with a 5
        </div>
      )}
      {drawnCard ? (
        <>
          <div className="whot-drawn-card-hint">
            Drew <strong>{drawnCard.number} {drawnCard.shape}</strong> — play it or pass
          </div>
          <button className="whot-btn whot-btn-warning whot-control-btn" onClick={onPassTurn} aria-label="Pass turn">
            <span className="whot-btn-icon" aria-hidden="true">
              <svg viewBox="0 0 24 24" role="img" focusable="false" aria-hidden="true">
                <path fill="currentColor" d="M7 7h6a4 4 0 0 1 0 8H8v3L4 14l4-4v3h5a2 2 0 0 0 0-4H7V7Z" />
              </svg>
            </span>
          </button>
        </>
      ) : (
        showDrawButton && (
          <button
            className="whot-btn whot-btn-primary whot-control-btn"
            onClick={onDrawCard}
            disabled={!canDraw || gameStatus === 'finished'}
            aria-label={pendingPick2Count > 0 ? `Draw ${pendingPick2Count}` : pendingPick3Active ? 'Draw 3' : 'Go to Market'}
          >
            <span className="whot-btn-icon" aria-hidden="true">
              <svg viewBox="0 0 24 24" role="img" focusable="false" aria-hidden="true">
                <path fill="currentColor" d="M6 2h9l3 3v13a2 2 0 0 1-2 2H6a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2Zm8 7H8v2h6V9Zm0 4H8v2h6v-2Z" />
              </svg>
            </span>
          </button>
        )
      )}
      <button className="whot-btn whot-control-btn" onClick={onRestart} aria-label="Restart">
        <span className="whot-btn-icon" aria-hidden="true">
          <svg viewBox="0 0 24 24" role="img" focusable="false" aria-hidden="true">
            <path fill="currentColor" d="M12 6V3L8 7l4 4V8a4 4 0 1 1-4 4H6a6 6 0 1 0 6-6Z" />
          </svg>
        </span>
      </button>
      {onOpenChat && (
        <button className="whot-btn whot-control-btn" onClick={onOpenChat} aria-label="Open chat" style={{ position: 'relative' }}>
          <span className="whot-btn-icon" style={{ fontSize: 20 }}>💬</span>
          {unreadChatCount > 0 && (
            <span
              style={{
                position: 'absolute',
                top: -4,
                right: -4,
                minWidth: 16,
                height: 16,
                borderRadius: 999,
                background: '#ef4444',
                color: '#fff',
                fontSize: 10,
                fontWeight: 700,
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                padding: '0 4px',
              }}
            >
              {unreadChatCount > 9 ? '9+' : unreadChatCount}
            </span>
          )}
        </button>
      )}
      <button className="whot-btn whot-btn-danger whot-control-btn" onClick={onLeave} aria-label="Leave">
        <span className="whot-btn-icon" aria-hidden="true">
          <svg viewBox="0 0 24 24" role="img" focusable="false" aria-hidden="true">
            <path fill="currentColor" d="M14 7V5H5a2 2 0 0 0-2 2v10a2 2 0 0 0 2 2h9v-2H5V7h9Zm7 5-4-4v3h-7v2h7v3l4-4Z" />
          </svg>
        </span>
      </button>
      {showStopConfetti && (
        <button className="whot-btn" style={{ background: '#f59e0b' }} onClick={onStopConfetti}>
          Stop Celebration
        </button>
      )}
    </div>
  );
}
